import React, {Fragment} from 'react';
import NoticeContent from '../../components/account/NoticeContent';

const Notices = () => {
    return (
        <Fragment>
                            
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">공지사항</div>
                </div>
            </div>
            <NoticeContent></NoticeContent>   
        </Fragment>
    );
};

export default Notices;


// WEBPACK FOOTER //
// ./src/containers/Account/Notices.js